<template>
  <!-- Strikes -->
  <!-- <td v-if="toggleView == 'toggleIncarceration' && detailedView" class="py-4 border-top" style="white-space: nowrap; z-index: 2">
    <select class="btn btn-sm mt-0 border-0 p-0 form-control-sm fs-6c" id="inputGroupSelect01" @change="setStrikes"
      v-model="chg.NumberOfStrikes">
      <option value="0" :selected="chg.NumberOfStrikes == '0'">0</option>
      <option value="1" :selected="chg.NumberOfStrikes == '1'">1</option>
      <option value="2+" :selected="chg.NumberOfStrikes == '2+'">2+</option>
      <option class="hidden" value="2+!" :selected="chg.NumberOfStrikes == '2+!'">
        2+
      </option>
    </select>
  </td> -->
  <!-- <td class="py-4 border-top pt-3" style="text-align: center; max-width: 40px" v-if="
    toggleView == 'toggleIncarceration' &&
    detailedView &&
    currentCase?.IsGang &&
    chg.CrimeTypeId == 5
  ">

  </td>
  <td v-else-if="toggleView == 'toggleIncarceration' && detailedView && currentCase?.IsGang"></td> -->
  <!-- Eligibility -->
  <!-- <td v-if="toggleView == 'toggleIncarceration'" class="py-4 border-top fs-6c" style="white-space: nowrap; text-align: center">
    <span :class=" detailedView ? '':'fs-5'" class="d-flex justify-content-center align-items-center mt-2">
      
      <span class=" d-flex align-items-center justify-content-center mt-2"
        v-if="chg.ProbationLimitation === 0">Eligible</span>
      <span class=" d-flex align-items-center justify-content-center mt-2"
        v-if="chg.ProbationLimitation === 1">Ineligible</span>
      <span class=" d-flex align-items-center justify-content-center mt-2"
        v-if="chg.ProbationLimitation === 2">Unusual</span>
      <span class=" d-flex align-items-center justify-content-center mt-2"
        v-if="chg.ProbationLimitation === 3">Unusual/Special A</span>
      <span class=" d-flex align-items-center justify-content-center mt-2"
        v-if="chg.ProbationLimitation === 4">Special A</span>
      <span class=" d-flex align-items-center justify-content-center mt-2"
        v-if="chg.ProbationLimitation === 5">Special B</span>
      </span>
  </td> -->

  <!-- Jail Term -->
  <!-- <td
    v-if="toggleView == 'toggleIncarceration'"
    class="py-4 border-top pt-1"
    style="white-space: nowrap z-index: 4;"
  >
    <div class="d-flex align-items-center justify-content-center" data-toggle="buttons">
      <input
        type="radio"
        class="btn-check"
        :name="`opt-jt-` + chg.Id"
        :id="`opt-jt-1-` + chg.Id"
        autocomplete="off"
      />
      <label
        v-if="chg?.CrimeSeverityId == 2"
        class="btn btn-secondary  mb-2 shadow-sm rounded border w-termradio  px-0"
        :for="`opt-jt-1-` + chg.Id"
        style="font-size: 8px"
        @click="emitJailTimePopup"
      >
        <span v-if="chg?.ProbationJailTimeDays !== null">
          {{ chg?.ProbationJailTimeDays }}d
        </span>
        <span v-else-if="chg?.CrimeSeverityId == 2">
          {{ chg.MinimumProbationJailTimeLength }}d -
          {{ chg.MaximumProbationJailTimeLength }}d
        </span>
      </label>
    </div>
  </td> -->

  <!-- TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD  -->
  <!-- TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD  -->
  <!-- TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD  -->
  <!-- TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD TRIAD  -->

  <td v-if="toggleView == 'toggleIncarceration'" class="m-0 mx-0 p-0 border-top" style="min-width: 175px" :class="isLastChargeInCharges ? 'border-bottom' : ''">
    <div class="d-flex align-items-center h-100">
      <!-- <i :class="detailedView ? '' : 'big-book'" class="fa fa-info-circle book_auth" data-section="InfoSectionPunishmentText" data-field="TriadPunishmentText"
        @click="
          emitPopupText({
            header: 'Punishment',
            body: chg.PunishmentText,
          })
          ">
      </i> -->

      <div v-if="!isSubstitution(chg)" :class="detailedView ? '' : 'btn-group-lg'" class="h-100">
        
        <span class="h-100" v-if="(chg.CrimeTypeId == 2 ) || chg.CrimeSeverityId == 1">
          <div style="width: 152px"></div>
        </span>
        <!-- if all terms are zeroes and exposure is death -->
        <span class="h-100" v-else-if="
          chg?.newExposureObject?.specialIndeterminate == 'DEATH' ||
          chg?.newExposureObject?.specialIndeterminate == 'LWOP' ||
          chg?.newExposureObject?.EnhancedDeath ||
          chg?.newExposureObject?.EnhancedLWOP
        ">
          <!-- TRIAD UPPER TERM -->
          <button class="btn btn-lg btn-primary  fs-5 " @click="
            setTriadTerm(
              chg?.IsDeath ||
                chg?.newExposureObject?.specialIndeterminate == 'DEATH'
                ? 1
                : 3,
              chg,
              $event
            )
            " :class="(chg?.IsDeath || chg?.newExposureObject?.EnhancedDeath ||
                chg?.newExposureObject?.specialIndeterminate == 'DEATH') && chg.SelectedTerm == 3
                ? 'btn-primary-outline'
                : 'btn-primary'
              " :style="!chg.IsDeath && !chg?.newExposureObject?.EnhancedDeath &&
                chg.newExposureObject?.specialIndeterminate !== 'DEATH'
                ? 'width: 98%'
                : 'width: 48%'
              ">
            LWOP
          </button>
          <button class="btn btn-lg  fs-5 " @click="setTriadTerm(3, chg, $event)" v-if="
            chg?.IsDeath || chg?.newExposureObject?.EnhancedDeath ||
            chg?.newExposureObject?.specialIndeterminate == 'DEATH'
          " style="width: 48%" :class="chg.SelectedTerm === 3 ? 'btn-primary' : 'btn-primary-outline'">
            DEATH
          </button>
          <!-- <input
            :checked="
              (chg?.IsDeath ||
                chg?.newExposureObject?.specialIndeterminate == 'DEATH') &&
              chg.SelectedTerm === 1
            "
            type="radio"
            class="btn-check"
            :name="`options1_` + chg.Id"
            :id="`o1U_` + chg.Id"
            autocomplete="off"
            @click="
              setTriadTerm(
                chg?.IsDeath ||
                  chg?.newExposureObject?.specialIndeterminate == 'DEATH'
                  ? 1
                  : 3,
                chg,
                $event
              )
            "
          />
          <label
            v-if="
              chg?.IsLWOP ||
              chg?.newExposureObject?.specialIndeterminate == 'LWOP' ||
              chg?.IsDeath ||
              chg?.newExposureObject?.specialIndeterminate == 'DEATH'
            "
            :class="detailedView ? '' : 'btn-lg'"
            class="btn btn-secondary   shadow-sm rounded w-termradio p-2"
            :style="
              !chg.IsDeath &&
              chg.newExposureObject?.specialIndeterminate !== 'DEATH'
                ? 'width: 98%'
                : 'width: 48%'
            "
            @click="setTriadTerm(1, chg, $event)"
            :for="`o1L_` + chg.Id"
            >LWOP</label
          >

          
          <input
            :checked="
              (chg?.IsDeath ||
                chg?.newExposureObject?.specialIndeterminate == 'DEATH') &&
              chg.SelectedTerm === 3
            "
            :class="detailedView ? '' : 'btn-lg'"
            type="radio"
            class="btn-check"
            :name="`options3_` + chg.Id"
            :id="`o1U_` + chg.Id"
            autocomplete="off"
            @click="setTriadTerm(3, chg, $event)"
          />
          <label
            v-if="
              chg?.IsDeath ||
              chg?.newExposureObject?.specialIndeterminate == 'DEATH'
            "
            :class="detailedView ? '' : 'btn-lg'"
            class="btn btn-secondary   shadow-sm rounded w-termradio p-2"
            style="width: 48%"
            @click="setTriadTerm(3, chg, $event)"
            :for="`o1U_` + chg.Id"
            >DEATH</label
          > -->
        </span>
        <!-- misdemeanor -->
        <span class="h-100" v-else-if="chg.CrimeSeverityId == 2 && !isMisdemeanorSubstitutedToAFelony">
          <button @click="emitJailTimePopup" class="btn btn-lg btn-primary  fs-5 " style="width: 98%"><span
              class="h-100" v-if="chg?.ProbationJailTimeDays">
              {{ chg?.ProbationJailTimeDays }}d
            </span>
            <span class="h-100" v-else-if="chg?.CrimeSeverityId == 2 && !attachedSubstitution">
              {{ chg.MinimumProbationJailTimeLength }}d -
              {{ chg.MaximumProbationJailTimeLength }}d
            </span>
            <span class="h-100" v-else>
              {{ attachedSubstitution.LowerTermLength * attachedSubstitution.LowerTermUnits }}d -
              {{ attachedSubstitution.UpperTermLength * attachedSubstitution.UpperTermUnits }}d
            </span>
          </button>
          <!-- <label
            v-if="chg?.CrimeSeverityId == 2"
            class="btn btn-primary  shadow-sm rounded border w-termradio px-0 big-btn"
            :for="`opt-jt-1-` + chg.Id"
            :class="detailedView ? '' : 'btn-lg'"
            @click="emitJailTimePopup"
          >
            <span class="h-100" v-if="chg?.ProbationJailTimeDays">
              {{ chg?.ProbationJailTimeDays }}d
            </span>
            <span class="h-100" v-else-if="chg?.CrimeSeverityId == 2">
              {{ chg.MinimumProbationJailTimeLength }}d -
              {{ chg.MaximumProbationJailTimeLength }}d
            </span>
          </label> -->
        </span>
        
        <!-- if all values are the same for all buttons -->
        <span class="h-100" v-else-if="
          getTriad(chg, chg.newExposureObject?.triad[0], '1') ==
          getTriad(chg, chg.newExposureObject?.triad[1], '1') &&
          getTriad(chg, chg.newExposureObject?.triad[1], '1') ==
          getTriad(chg, chg.newExposureObject?.triad[2], '1')
        ">
          <!-- <input
            :checked="chg.SelectedTerm === 3"
            type="radio"
            class="btn-check"
            :name="`options1_` + chg.Id"
            :id="`o1U_` + chg.Id"
            autocomplete="off"
            @click="setTriadTerm(3, chg, $event)"
          /> -->
          <button v-if="isCZ(chg.SubSentenceNum) && chg.CrimeType == 'Probation allegation'"
            class="btn btn-lg btn-primary" style="width: 98%">
            Probation Limitation
          </button>
          <!-- 
          <label
            v-else-if="isCZ(chg.SubSentenceNum)"
            :class="detailedView ? '' : 'btn-lg'"
            class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio_full big-btn"
            style="width: 152px"
            @click="setTriadTerm(3, chg, $event)"
            :for="`o1U_` + chg.Id"
            >{{
              chg.newExposureObject?.formattedTriad?.[2]
                ? chg.newExposureObject?.formattedTriad?.[2]
                : "0d"
            }}
          </label> -->
          <button v-else style="width: 98%" class="btn  fs-5 btn-primary rounded px-3 btn-lg" @click="setTriadTerm(3, chg, $event)"
            >
            {{
              chg.newExposureObject?.formattedTriad?.[2]
                ? chg.newExposureObject?.formattedTriad?.[2]
                : "0d"
            }}
          </button>
        </span>

        <!-- if lower and middle term are both zeros and upper term is > 365 days -->
        <span class="h-100" v-else-if="
          chg.newExposureObject?.triad[2] > 0 &&
          chg.newExposureObject?.triad[0] == 0 &&
          chg.newExposureObject?.triad[1] == 0 &&
          isCZ(chg.SubSentenceNum) &&
          chg.newExposureObject?.triad[2] > 365
        ">
          <button style="width: 98%" class="btn  fs-5  rounded px-3 btn-lg btn-primary" @click="setTriadTerm(3, chg, $event)"
            >
            {{ chg.newExposureObject?.formattedTriad?.[2] }}
          </button>
          <!-- <input
            :checked="chg.SelectedTerm === 3"
            type="radio"
            class="btn-check"
            :name="`options1_` + chg.Id"
            :id="`o1U_` + chg.Id"
            autocomplete="off"
            @click="setTriadTerm(3, chg, $event)"
          />

          <label
            :class="detailedView ? '' : 'btn-lg'"
            class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio_full big-btn"
            @click="setTriadTerm(3, chg, $event)"
            :for="`o1U_` + chg.Id"
            style="width: 152px"
          >
            {{ chg.newExposureObject?.formattedTriad?.[2] }}
          </label> -->
        </span>
        <span class="h-100" v-else>
          <!-- TRIAD LOWER TERM -->
          <button style="width: 30%" class="btn  fs-5  rounded px-3 btn-lg" @click="setTriadTerm(1, chg, $event)"
            :class="chg.SelectedTerm === 1 ? 'btn-primary' : 'btn-primary-outline'">
            {{ chg.newExposureObject?.formattedTriad?.[0] }}
          </button>
          <!-- <input v-if="isCZ(chg.SubSentenceNum)" :checked="chg.SelectedTerm === 1" type="radio" class="btn-check"
                  :name="`options1_` + chg.Id" :id="`o1L_` + chg.Id" autocomplete="off"
                  @click="setTriadTerm(1, chg, $event)" />
                <label :class=" chg.SelectedTerm === 1 ? 'btn-primary':'btn-primary-outline'" v-if="isCZ(chg.SubSentenceNum) && chg.CrimeSeverityName != 'Felony'"
                  class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio px-3 btn-lg" style="width: 48px"
                  @click="setTriadTerm(1, chg, $event)" :for="`o1L_` + chg.Id">{{
                    chg.newExposureObject?.formattedTriad?.[0]
                    ? chg.newExposureObject?.formattedTriad?.[0]
                    : `0d`
                  }}
                </label> -->
          <!-- <label :class=" detailedView ? '':'btn-lg'" v-else class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio px-3" style="width: 48px"
                  @click="setTriadTerm(1, chg, $event)" :for="`o1L_` + chg.Id">{{ chg.newExposureObject?.formattedTriad?.[0]
                  }}
                </label> -->

          <!-- TRIAD MIDDLE TERM -->
          <button style="width: 30%" v-if="chg.CrimeSeverityId == 3 || isMisdemeanorSubstitutedToAFelony" class="btn  fs-5  rounded px-3 btn-lg"
            @click="setTriadTerm(2, chg, $event)"
            :class="chg.SelectedTerm === 2 ? 'btn-primary' : 'btn-primary-outline'">
            {{ chg.newExposureObject?.formattedTriad?.[1] }}
          </button>
          <!-- <input v-if="isCZ(chg.SubSentenceNum) && chg.CrimeSeverityName != 'Misdemeanor'"
                  :checked="chg.SelectedTerm === 2" type="radio" class="btn-check" :name="`options1_` + chg.Id"
                  :id="`o1M_` + chg.Id" autocomplete="off" @click="setTriadTerm(2, chg, $event)" />
                <label :class=" chg.SelectedTerm === 2 ? 'btn-primary':'btn-primary-outline'" v-if="isCZ(chg.SubSentenceNum) && chg.CrimeSeverityName != 'Misdemeanor'"
                  class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio px-3 btn-lg" style="width: 48px"
                  @click="setTriadTerm(2, chg, $event)" :for="`o1M_` + chg.Id">{{ chg.newExposureObject?.formattedTriad?.[1]
                  }}</label>

                <label :class=" detailedView ? '':'btn-lg'" v-if="chg.CrimeSeverityName == 'Misdemeanor'"
                  class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio bg-transparent border-0 shadow-none px-3"
                  style="width: 48px" @click="setTriadTerm(2, chg, $event)" :for="`o1M_` + chg.Id"></label> -->

          <!-- TRIAD UPPER TERM -->

          <!-- <input :checked="chg.SelectedTerm === 3" type="radio" class="btn-check" :name="`options1_` + chg.Id"
                  :id="`o1U_` + chg.Id" autocomplete="off" @click="setTriadTerm(3, chg, $event)" />
                <label :class="chg.SelectedTerm === 3 ? 'btn-primary':'btn-primary-outline'" v-if="isCZ(chg.SubSentenceNum)"
                  class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio px-3 btn-lg" style="width: 48px"
                  @click="setTriadTerm(3, chg, $event)" :for="`o1U_` + chg.Id">{{ chg.newExposureObject?.formattedTriad?.[2]
                  }}</label>
                <label :class=" detailedView ? '':'btn-lg'" v-if="!isCZ(chg.SubSentenceNum)"
                  class="btn btn-secondary  mb-2 shadow-sm rounded w-termradio_full" :for="`o1U_` + chg.Id"
                  @click="setTriadTerm(3, chg, $event)">
                  {{
                    chg.SubSentenceNumText.exp.split("-")[0] +
                    "-" +
                    (chg.SubSentenceNumText.exp
                      .trim()
                      .substring(
                        chg.SubSentenceNumText.exp.trim().length - 1,
                        chg.SubSentenceNumText.exp.trim().length
                      ) == "L"
                      ? "Life"
                      : "")
                  }}
                </label> -->
          <button style="width: 30%" class="btn  fs-5  rounded px-3 btn-lg" @click="setTriadTerm(3, chg, $event)"
            :class="chg.SelectedTerm === 3 ? 'btn-primary' : 'btn-primary-outline'">
            {{ chg.newExposureObject?.formattedTriad?.[2] }}
          </button>
        </span>
      </div>
    </div>
  </td>

  <!-- CONCURRENT CONSECUTIVE -->
  <!-- <td v-if="toggleView == 'toggleIncarceration' && detailedView" class=" border-topm-0 mx-0 p-0 py-4">
    <div class="d-flex align-items-center justify-content-center">
      
      <button style="width: 50px" class="btn m-0 shadow-sm rounded w-termradio mr-2"
        @click="toggleConcurrency(false, chg)" :class="!chg.Concurrency ? 'btn-primary' : 'btn-primary-outline'">
        CS
      </button>
      <button style="width: 50px" class="btn btn-secondary m-0 shadow-sm rounded w-termradio"
        @click="toggleConcurrency(true, chg)" :style="chg.Concurrency ? 'btn-primary' : 'btn-primary-outline'"
        :class="chg.IsMandatoryConsecutive ? 'hidden' : ''">
        CC
      </button>
      <div v-if="chg.IsMandatoryConsecutive" style="width: 50px"></div>

      <div class="background"></div>
    </div>
  </td> -->
  <td v-if="toggleView == 'toggleIncarceration'" class=" border-top text-center p-0 bg-transparent" :class="isLastChargeInCharges ? 'border-bottom' : ''">
    <span v-if="chg.newExposureObject?.isPrincipal == 1"
      class="fw-bold fs-5 ta-c d-flex justify-content-center align-items-center">
      
      <i class="fa fa-check "></i>
      <!-- &#10003; -->
      <!-- <svg
        style="width: 16px"
        fill="#000000"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 78.369 78.369"
        xml:space="preserve"
      >
        <g>
          <path
            d="M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704
            c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704
            C78.477,17.894,78.477,18.586,78.049,19.015z"
          />
        </g>
      </svg> -->
    </span>
    <span v-else-if="usesSixSevenSixScheme(chg)"
      class="fs-6c ta-c d-flex justify-content-center align-items-center">
      N/A
    </span>
  </td>

  <!-- EXPOSURE -->
  <td v-if="toggleView == 'toggleIncarceration'" class=" border-top text-center p-0 py-3 bg-transparent" :class="isLastChargeInCharges ? 'border-bottom' : ''">
    <div class="d-flex justify-content-center align-items-center" style="z-index: 3; min-width: 100px">
      <!-- <i v-if="chg?.CrimeTypeId !== 3 && chg.newExposureObject?.populatedRuleWords?.length > 0
        " :class="detailedView ? '' : 'big-book'" class="fa fa-info-circle book_auth ml-2" @click="ruleWordsPopup(charge)">
      </i> -->
      <!-- <button class="btn btn-primary-outline" @click="toggleRuleWordsPopup(charge)"> -->
      <!-- <div :class="detailedView ? '' : 'fs-5'"
        v-if="chg.ChargeStatus == 0 && !chg?.newExposureObject?.specialIndeterminate">
        {{
          chg.newExposureObject?.determinate
            ? parseDays(false, chg.newExposureObject.determinate)
            : chg.newExposureObject?.indeterminate
              ? ""
              : "0d"
        }}
        {{
          chg.newExposureObject?.determinate && chg.newExposureObject?.indeterminate
            ? " + "
            : ""
        }}
        {{
          chg.newExposureObject?.indeterminate
            ? parseDays(false, chg.newExposureObject?.indeterminate) !== "LWOP"
              ? parseDays(false, chg.newExposureObject?.indeterminate) + "-L"
              : "LWOP"
            : ""
        }}
      </div>
      <div :class="detailedView ? '' : 'fs-5'"
        v-else-if="chg.ChargeStatus == 0 && chg?.newExposureObject?.specialIndeterminate">
        <span v-if="chg.newExposureObject?.specialIndeterminate == 'DEATH'">{{
          chg.SelectedTerm == 1 ? "LWOP" : "DEATH"
        }}</span>
        <span v-else>
          {{ chg.newExposureObject.specialIndeterminate }}
        </span>
      </div>
      <div :class="detailedView ? '' : 'fs-5'" v-else>
        {{ chargeStatusArray[chg.ChargeStatus] }}
      </div> -->
      <div class="fs-5">
        {{ displayFormattedSentence }}
      </div>
      <!-- </button> -->

    </div>
  </td>

  <!-- <SC :app_token="token" :currentCase="currentCase"></SC> -->
</template>

<script>
import axios from "axios";
import moment from "moment";
import SC from "../../components/utils/sharedComponent.vue";
import { usesSixSevenSixScheme } from "../../chargeControlHelpers";

export default {
  name: "CDBIncarceration",
  props: ["chg", "toggleView", "app_token", "noActivity", "currentCase", "detailedView", 'charges'],
  components: { SC },
  computed: {
    displayFormattedSentence() {
        return SC.displayFormattedSentence(this.chg);
    },
    isMisdemeanorSubstitutedToAFelony() {
      return SC.isMisdemeanorSubstitutedToAFelony(this.chg, this.charges);
    },
    isLastChargeInCharges(){
      return this.charges[this.charges?.length - 1]?.Id == this.chg.Id
    },
    attachedSubstitution() {
      const attachedSubstitutionIndex = this.charges.findIndex(chg => {
        return chg.CrimeTypeId == 2 && chg.ChargeStatus == 0 && chg.CountNumber == this.chg.CountNumber
      })
      return this.charges[attachedSubstitutionIndex]
    }
  },
  data() {
    return {
      selectedCase: null,
      chargeStatusArray: [
        "Convicted",
        "Acquitted",
        "Dismissed",
        "Stayed",
        "Stayed",
        "Stayed",
        "Stayed",
      ],
      // charge: {}
    };
  },

  methods: {
    usesSixSevenSixScheme, // imported: 667.6 rows show N/A in the principal column
    isCZ(s) {
      return SC.isCZ(s);
    },

    isSubstitution(chg) {
      return SC.isSubstitution(chg);
    },

    emitCalc() {
      this.$emit("onCalc");
    },
    emitJailTimePopup() {
      // console.log("POPUP");
      this.$emit("jailTimePopup", {
        charge: this.chg,
      });
    },
    async setTriadTerm(v, chg, event) {
      // console.log("setTriadTerm::selectedCase::", this.selectedCase);
      // console.log(chg);
      // console.log(v);
      this.chg.SelectedTerm = v;
      let charges = await SC.setTriadTerm(v, chg, event, this.app_token, chg.CaseId).then(
        (charges) => {
          this.$emit("onCalc");
          
        }
      );
    },

   
    getTriad(chg, termLength, termUnits) {
      return SC.getTriad(chg, termLength, termUnits);
    },

    emitProbationText(chg) {
      let popupText = chg.ProbationLimitationLawText;
      if (chg.ProbationLimitation === 5) {
        popupText = `(a) Notwithstanding Section 1203 or any other law, probation shall not be granted to, nor shall the execution or imposition of sentence be suspended for, nor shall a finding bringing the defendant within the provisions of this section be stricken pursuant to Section 1385 for, any of the following persons:

        <br/><br/>(1) A person who is convicted of violating Section 288 or 288.5 when the act is committed by the use of force, violence, duress, menace, or fear of immediate and unlawful bodily injury on the victim or another person.

        <br/><br/>(2) A person who caused bodily injury on the child victim in committing a violation of Section 288 or 288.5.

        <br/><br/>(3) A person who is convicted of a violation of Section 288 or 288.5 and who was a stranger to the child victim or befriended the child victim for the purpose of committing an act in violation of Section 288 or 288.5, unless the defendant honestly and reasonably believed the victim was 14 years of age or older.

        <br/><br/>(4) A person who used a weapon during the commission of a violation of Section 288 or 288.5.

        <br/><br/>(5) A person who is convicted of committing a violation of Section 288 or 288.5 and who has been previously convicted of a violation of Section 261, 264.1, 266, 266c, 267, 285, 286, 287, 288, 288.5, or 289, or former Section 262 or 288a, or of assaulting another person with intent to commit a crime specified in this paragraph in violation of Section 220, or who has been previously convicted in another state of an offense which, if committed or attempted in this state, would constitute an offense enumerated in this paragraph.

        <br/><br/>(6) A person who violated Section 288 or 288.5 while kidnapping the child victim in violation of Section 207, 209, or 209.5.

        <br/><br/>(7) A person who is convicted of committing a violation of Section 288 or 288.5 against more than one victim.

        <br/><br/>(8) A person who, in violating Section 288 or 288.5, has substantial sexual conduct with a victim who is under 14 years of age.

        <br/><br/>(9) A person who, in violating Section 288 or 288.5, used obscene matter, as defined in Section 311, or matter, as defined in Section 311, depicting sexual conduct, as defined in Section 311.3.

        <br/><br/>(b) “Substantial sexual conduct” means penetration of the vagina or rectum of either the victim or the offender by the penis of the other or by any foreign object, oral copulation, or masturbation of either the victim or the offender.

        <br/><br/>(c) (1) Except for a violation of subdivision (b) of Section 288, this section shall only apply if the existence of any fact required in subdivision (a) is alleged in the accusatory pleading and is either admitted by the defendant in open court, or found to be true by the trier of fact.

        <br/><br/>(2) For the existence of any fact under paragraph (7) of subdivision (a), the allegation must be made pursuant to this section.

        <br/><br/>(d) (1) If a person is convicted of a violation of Section 288 or 288.5, and the factors listed in subdivision (a) are not pled or proven, probation may be granted only if the following terms and conditions are met:

        <br/><br/>(A) If the defendant is a member of the victim’s household, the court finds that probation is in the best interest of the child victim.

        <br/><br/>(B) The court finds that rehabilitation of the defendant is feasible and that the defendant is amenable to undergoing treatment, and the defendant is placed in a recognized treatment program designed to deal with child molestation immediately after the grant of probation or the suspension of execution or imposition of sentence.

        <br/><br/>(C) If the defendant is a member of the victim’s household, probation shall not be granted unless the defendant is removed from the household of the victim until the court determines that the best interests of the victim would be served by the defendant’s return. While removed from the household, the court shall prohibit contact by the defendant with the victim, with the exception that the court may permit supervised contact, upon the request of the director of the court-ordered supervised treatment program, and with the agreement of the victim and the victim’s parent or legal guardian, other than the defendant.

        <br/><br/>(D) If the defendant is not a member of the victim’s household, the court shall prohibit the defendant from being placed or residing within one-half mile of the child victim’s residence for the duration of the probation term unless the court, on the record, states its reasons for finding that this residency restriction would not serve the best interests of the victim.

        <br/><br/>(E) The court finds that there is no threat of physical harm to the victim if probation is granted.

        <br/><br/>(2) The court shall state its reasons on the record for whatever sentence it imposes on the defendant.

        <br/><br/>(3) The court shall order the psychiatrist or psychologist who is appointed pursuant to Section 288.1 to include a consideration of the factors specified in subparagraphs (A), (B), and (C) of paragraph (1) in making the report to the court.

        <br/><br/>(4) The court shall order the defendant to comply with all probation requirements, including the requirements to attend counseling, keep all program appointments, and pay program fees based upon ability to pay.

        <br/><br/>(5) A victim shall not be compelled to participate in a program or counseling, and a program may not condition a defendant’s enrollment on participation by the victim.

        <br/><br/>(e) As used in subdivision (d), the following definitions apply:

        <br/><br/>(1) “Contact with the victim” includes all physical contact, being in the presence of the victim, communicating by any means, including by a third party acting on behalf of the defendant, or sending any gifts.

        <br/><br/>(2) “Recognized treatment program” means a program that consists of the following components:

        <br/><br/>(A) Substantial expertise in the treatment of child sexual abuse.

        <br/><br/>(B) A treatment regimen designed to specifically address the offense.

        <br/><br/>(C) The ability to serve indigent clients.

        <br/><br/>(D) Adequate reporting requirements to ensure that all persons who, after being ordered to attend and complete a program, may be identified for either failure to enroll in, or failure to successfully complete, the program, or for the successful completion of the program as ordered. The program shall notify the court and the probation department, in writing, within the period of time and in the manner specified by the court of any person who fails to complete the program. Notification shall be given if the program determines that the defendant is performing unsatisfactorily or if the defendant is not benefiting from the education, treatment, or counseling.
        <br/><br/>[PC § 1203.066]
        <br /><br /><br />(a) Notwithstanding any other law, before probation may be granted to any person convicted of a felony specified in Section 261, 264.1, 286, 287, 288, 288.5, or 289, or former Section 262 or 288a, who is eligible for probation, the court shall do all of the following:

        <br /><br />(1) Order the defendant evaluated pursuant to Section 1203.03, or similar evaluation by the county probation department.

        <br /><br />(2) Conduct a hearing at the time of sentencing to determine if probation of the defendant would pose a threat to the victim. The victim shall be notified of the hearing by the prosecuting attorney and given an opportunity to address the court.

        <br /><br />(3) Order any psychiatrist or psychologist appointed pursuant to Section 288.1 to include a consideration of the threat to the victim and the defendant’s potential for positive response to treatment in making the report to the court. This section does not require the court to order an examination of the victim.

        <br /><br />(b) The terms of probation for persons placed on formal probation for an offense that requires registration pursuant to Sections 290 to 290.023, inclusive, shall include all of the following:

        <br /><br />(1) A person placed on formal probation prior to July 1, 2012, shall participate in an approved sex offender management program, following the standards developed pursuant to Section 9003, for a period of not less than one year or the remaining term of probation if it is less than one year. The length of the period in the program is to be determined by the certified sex offender management professional in consultation with the probation officer and as approved by the court. Participation in this program applies to every person described without regard to when the person’s crime or crimes were committed.

        <br /><br />(2) A person placed on formal probation on or after July 1, 2012, shall successfully complete a sex offender management program, following the standards developed pursuant to Section 9003, as a condition of release from probation. The length of the period in the program shall be not less than one year, up to the entire period of probation, as determined by the certified sex offender management professional in consultation with the probation officer and as approved by the court. Participation in this program applies to each person without regard to when the person’s crime or crimes were committed.

        <br /><br />(3) Waiver of any privilege against self-incrimination and participation in polygraph examinations, which shall be part of the sex offender management program.

        <br /><br />(4) Waiver of any psychotherapist-patient privilege to enable communication between the sex offender management professional and supervising probation officer, pursuant to Section 290.09.

        <br /><br />(c) A defendant ordered to be placed in an approved sex offender management program pursuant to subdivision (b) shall be responsible for paying the expense of participation in the program as determined by the court. The court shall take into consideration the ability of the defendant to pay, and a defendant shall not be denied probation because of their inability to pay.
        
        <br/><br/>[PC § 1203.067]
        `;
      } else if (chg.ProbationLimitation == 0) {
        popupText = "This crime is not statutorily ineligibile for probation.";
      }
      this.$emit("displayModalPopup", {
        header: "Probation Eligibility",
        body: popupText,
      });
    },

    displayLawText(params) {
      //SC.displayLawText(params, this.chg, this.app_attr);
      this.$emit("displayLawText", {
        chg: this.chg,
        app_str: this.app_attr,
        params: params,
        origin: this.$options,
      });
    },

    setStrikes() {
      SC.postChargeField(
        this.app_token,
        this.chg.Id,
        "NumberOfStrikes",
        this.chg.NumberOfStrikes
      );
      this.$emit("onCalc");
    },
    parseDays(truefalse, total_ind) {
      return SC.convertExpoDaysToString(total_ind);
    },
    // toggleConcurrency(bool, chg) {
    //   // console.log(bool);
    //   if (!chg.IsMandatoryConsecutive) {
    //     chg.Concurrency = bool;
    //   }
    //   SC.postChargeFieldValue(
    //     chg.Id,
    //     "Concurrency",
    //     chg.Concurrency,
    //     this.app_token,
    //     chg.CaseId
    //   ).then((result) => {
    //     this.$emit("onCalc");
    //   });
    //   // console.log(chg);
    // },
    emitPopupText(obj) {
      this.$emit("displayModalPopup", obj);
    },
    ruleWordsPopup() {
      this.$emit("ruleWordsPopup", this.chg);
    },
    isIndeterminate(chg) {
      return SC.isIndeterminate(chg);
    },
    isViolent(chg) {
      // console.log("IsViolent", SC.isViolent(chg));
      return SC.isViolent(chg);
    },
    isSerious(chg) {
      // console.log("IsSerious", SC.isSerious(chg));

      return SC.isSerious(chg);
    },
    toggleRuleWordsPopup(charge) {
      this.$emit("displayModalPopup", {
        header: 'Rule Words',
        body: `<p>${this.chg.newExposureObject?.ruleWords?.join('</p><br/><p>')}</p>`,
      });
    },
    
  },

  mounted() {
    if (this.currentCase) {
      this.selectedCase = this.currentCase;
      // this.charge = this.chg
    }
    // console.log("this.toggleView:::", this.toggleView);
    // console.log("this.selectedCase:::", this.selectedCase);
    // console.log("this.selectedCase:::", this.selectedCase);
    
  },
};
</script>

<style scoped>
.hidden {
  display: none !important;
}


.btn-group-lg {
  width: 100%;
  min-width: 250px;
}

.btn-group-lg>span {
  display: flex !important;
  flex-wrap: nowrap !important;
  justify-content: space-between !important;
}

.btn-group-lg>span>label {
  width: 30% !important;

  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

}

.btn-group-lg>span>label.big-btn {
  width: 100% !important;

  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

}
</style>
